import { Component, Inject, PLATFORM_ID } from '@angular/core';

import { Router, RouterModule } from '@angular/router';
import { CtxButtonComponent } from '../button/button.component';
import { environment, projectEnv } from 'utils';
import { CtxCompanyLogoComponent } from '../company-logo/company-logo.component';
import { CtxAppBarComponent } from '../app-bar/app-bar.component';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'ctx-auth-base-layout',
  standalone: true,
  imports: [
    RouterModule,
    CtxButtonComponent,
    CtxCompanyLogoComponent,
    CtxAppBarComponent,
  ],
  templateUrl: './auth-base-layout.component.html',
})
export class CtxAuthBaseLayoutComponent {
  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: string
  ) {}

  get isSignUpPage() {
    if (isPlatformBrowser(this.platformId)) {
      return window.location.pathname.endsWith('/signup');
    } else {
      /** just to return code in all cases, this function's value will have effect on browsr only */
      return true;
    }
  }

  get showSignup() {
    return (
      projectEnv.get('projectName') === 'admin-portal' &&
      environment.get('name') !== 'on-premise' &&
      !this.isSignUpPage
    );
  }

  get showLogin() {
    return (
      projectEnv.get('projectName') === 'admin-portal' && this.isSignUpPage
    );
  }
  get showGoToWebsite() {
    return (
      projectEnv.get('projectName') === 'admin-portal' &&
      environment.get('name') !== 'on-premise'
    );
  }

  /** Opens the website in a new tab */
  goToWebsite() {
    window.open(WEBSITE_BASE_URL, '_blank');
  }
}

const WEBSITE_BASE_URL = 'https://cryptlex.com';
